import { render, staticRenderFns } from "./vue-select.vue?vue&type=template&id=71149723"
import script from "./vue-select.vue?vue&type=script&lang=js"
export * from "./vue-select.vue?vue&type=script&lang=js"
import style0 from "./vue-select.vue?vue&type=style&index=0&id=71149723&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports